import { lazy } from 'react';
export const TraderStatementOfAccount = lazy(() => import('@/Reports/TraderStatementOfAccount'));
export const TraderCashbackTendered = lazy(() => import('@//Reports/TraderCashbackTendered'));
export const BasketHashExceptions = lazy(() => import('@/Reports/BasketHashExceptions'));
export const HashExceptions = lazy(() => import('@/Reports/HashExceptions'));
export const DeviceHash = lazy(() => import('@/Reports/DeviceHash'));
